import { WcDivider, WcStack, WcTypography } from "@bpipartners/webui";
import React from "react";
import { BreadCrumbs, BreadCrumbsProps } from "@guberno/ui";
import { useTheme } from "@guberno/utils/theme";

interface SubHeaderProps {
  children?: React.ReactNode;
  pageTitle: string;
  pageDescription?: string;
  breadcrumbComponent?: React.ReactNode;
  breadcrumbsProps?: BreadCrumbsProps;
}

export const SubHeader = ({ children, pageTitle, pageDescription, breadcrumbComponent, breadcrumbsProps }: SubHeaderProps) => {
  const theme = useTheme();

  return (
    <WcStack
      height={theme.dimensions.subHeaderHeight}
      id="SubHeader"
      marginBottom={8}
      // divider will fall outside this stack, even though it's inside, messing the styling up
      // thus, border
      sx={{ borderBottom: "1px solid lightgray" }}
    >
      <WcStack id="breadCrumbStack" minHeight={theme.dimensions.breadCrumbHeight} justifyContent={"center"}>
        {breadcrumbComponent && breadcrumbComponent}
        {!breadcrumbComponent && breadcrumbsProps && <BreadCrumbs {...breadcrumbsProps} />}
      </WcStack>

      <WcStack>
        <WcStack spacing={2} justifyContent={"space-between"} alignItems={"center"} direction={"row"}>
          <WcStack width={"100%"}>
            <WcTypography variant={"h4"} fontWeight={600} color={theme.appColors.primary} suppressHydrationWarning>
              {pageTitle}
            </WcTypography>
            <WcTypography variant={"h6"} color={theme.appColors.primary} suppressHydrationWarning>
              {pageDescription}
            </WcTypography>
          </WcStack>

          <WcStack width={"100%"}>{children}</WcStack>
        </WcStack>
        <WcStack direction="row" spacing={2}>
          {/* TODO: Implement dynamic page description */}
          {/*
          {pageDescriptionPlate ? (
            pageDescriptionPlate
          ) : ( */}
          {/* <WcTypography variant={"body1"} color={theme.appColors.primary}>
            {pageDescription}
          </WcTypography> */}
          {/* )} */}
        </WcStack>
      </WcStack>
    </WcStack>
  );
};

export default SubHeader;
